// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__1EQ8R","grid-left-col":"styles_grid-left-col__3VOqQ"};